import Vue from "vue";
import Vuetify from 'vuetify/lib'
import CoinsUt from "./CoinsUt.vue";
import router from "./router.js";
import store from "./store.js";
import { fb } from "./firebase.js"




Vue.use(Vuetify)
Vue.use(store);
Vue.use(router);

const opts = {}
const vuetify = new Vuetify(opts)

store.dispatch("commitFirebase", fb); //firbase instance with credentials: see ./firebase.js

if (process.env.NODE_ENV == "production") {
  //turn off devtools in production.
  store.dispatch("commitFrontEndServerURL", "https://upp.wasatch.utah.gov/");
  store.dispatch("commitBackEndServerURL", "dbb/");
  Vue.config.devtools = false;
  Vue.config.productionTip = true;
  console.log("Build Level: " + process.env.NODE_ENV); //https://cli.vuejs.org/guide/mode-and-env.html#modes
} else {
  //Allow devtools in development.
  store.dispatch("commitFrontEndServerURL", "http://localhost:8080/")
  store.dispatch("commitBackEndServerURL", "http://localhost:3000/")
  //store.dispatch("commitFrontEndServerURL", "https://upp.wasatch.utah.gov/");
  //store.dispatch("commitBackEndServerURL", "dbb/");
  Vue.config.devtools = true;
  Vue.config.productionTip = false;
  console.log("Build Level: " + process.env.NODE_ENV); //https://cli.vuejs.org/guide/mode-and-env.html#modes
}

/*
This provides every instance of vue with the methods listed inside.
cQuery adds the database whether or not the sever requests it.
*/
Vue.mixin({
  methods: {

    cQuery(destination, params = {}) {
      let query =
        store.getters.backEndServerURL +
        "sql/" +
        destination +
        ".js?db=" +
        store.getters.county.ID;
      const keys = Object.keys(params);
      for (let i = 0; i < keys.length; i++) {
        query += "&" + keys[i] + "=" + params[keys[i]];
      }
      return fetch(query);
    },

    beEmail(destination, params = {}) {
      let purl =
        store.getters.backEndServerURL +
        "email/" +
        destination +
        ".js?ID=" +
        store.getters.county.ID;
      const keys = Object.keys(params);
      for (let i = 0; i < keys.length; i++) {
        purl += "&" + keys[i] + "=" + params[keys[i]];
      }
      return fetch(purl);
    }
  }
});



/*
This creates the Vue instance and mounts it to the <div> in public/index.
*/
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(CoinsUt) //should match root component in CoinsUt.vue
}).$mount("#CoinsApp"); //should match id="CoinsApp" in index.html

/*
 * meta:{ parentPage: PAGE } helps in determining transitions. If a page has a parent
 * page, then the transitions between the two will be slide transitions. Otherwise,
 * It will be a fade transition.
*/
router.beforeEach((to, from, next) => {
  let user = JSON.parse(window.localStorage.getItem("deviceUser"))
    if (to.meta.authRequired && !user.emailVerified) {
      next({
        path: "/",
        query: { redirect: to.fullPath }
        });
    } else {
      next(); 
    }
});


export default Vue;


